/** Google Ads tag IDs (gtag.js). One snippet, one config per account. */
export const GOOGLE_ADS_TAG_IDS = ['AW-18026715452', 'AW-18539649913']

/** Notify Google Ads of SPA navigations (initial load is configured in index.html). */
export function trackGoogleAdsPageView(pagePath) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return
  const path = pagePath ?? `${window.location.pathname}${window.location.search}`
  for (const tagId of GOOGLE_ADS_TAG_IDS) {
    window.gtag('config', tagId, { page_path: path })
  }
}
